// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileSyncOutlinedSvg from "@ant-design/icons-svg/es/asn/FileSyncOutlined";
import AntdIcon from '../components/AntdIcon';

var FileSyncOutlined = function FileSyncOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileSyncOutlinedSvg
  }));
};

FileSyncOutlined.displayName = 'FileSyncOutlined';
export default React.forwardRef(FileSyncOutlined);